import { type LucideIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

interface EmptyStateProps {
  message: string;
  sub?: string;
  icon?: LucideIcon;
  emoji?: string;
  className?: string;
}

export function EmptyState({ message, sub, icon: Icon, emoji, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 py-12 px-6 text-center', className)}>
      {emoji && (
        <div className="text-4xl select-none">{emoji}</div>
      )}
      {Icon && !emoji && (
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-muted">
          <Icon className="h-6 w-6 text-muted-foreground" />
        </div>
      )}
      <div>
        <p className="text-sm font-medium text-foreground">{message}</p>
        {sub && <p className="mt-1 text-xs text-muted-foreground max-w-xs">{sub}</p>}
      </div>
    </div>
  );
}
